import * as ActionTypes from '../../../constants';

// `sketches` is a flat array of projects (school scale — no server pagination/metadata).
const sketches = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.SET_PROJECTS:
      return action.projects;
    case ActionTypes.DELETE_PROJECT:
      return state.filter((sketch) => sketch.id !== action.id);
    case ActionTypes.CHANGE_VISIBILITY:
      return state.map((sketch) =>
        sketch.id === action.payload.id
          ? { ...sketch, visibility: action.payload.visibility }
          : sketch
      );
    case ActionTypes.RENAME_PROJECT:
      return state.map((sketch) =>
        sketch.id === action.payload.id
          ? { ...sketch, name: action.payload.name }
          : sketch
      );
    default:
      return state;
  }
};

export default sketches;
